import React, { useEffect, useState } from 'react'
import { Card, Form, Input, Button, message, Typography } from 'antd'
import { getPulseRelease, updatePulseRelease } from 'api/pulse/pulseRelease'

const { Title } = Typography
const { TextArea } = Input

/**
 * Pulse Release configuration page for system admins.
 * Configure latest recommended version, APK URL, and description for the Pulse app.
 */
const PulseRelease: React.FC = () => {
	const [form] = Form.useForm()
	const [loading, setLoading] = useState(false)
	const [fetching, setFetching] = useState(true)

	useEffect(() => {
		const fetch = async () => {
			setFetching(true)
			try {
				const data = await getPulseRelease()
				form.setFieldsValue({
					pulseVersion: data.pulseVersion ?? '',
					apkUrl: data.apkUrl ?? '',
					description: data.description ?? '',
				})
			} catch {
				message.error('Failed to load Pulse release settings')
			} finally {
				setFetching(false)
			}
		}
		fetch()
	}, [form])

	const onFinish = async (values: {
		pulseVersion: string
		apkUrl: string
		description: string
	}) => {
		setLoading(true)
		try {
			await updatePulseRelease(values)
			message.success('Pulse release settings saved')
		} catch {
			message.error('Failed to save settings')
		} finally {
			setLoading(false)
		}
	}

	return (
		<>
			<Title level={4}>Pulse Release</Title>
			<p style={{ marginBottom: 24, color: '#666' }}>
				Configure the latest recommended version and APK link for the Pulse app. The
				app checks daily at 10:00 and notifies users when an update is available.
			</p>
			<Card loading={fetching}>
				<Form
					form={form}
					layout='vertical'
					onFinish={onFinish}
					style={{ maxWidth: 560 }}
				>
					<Form.Item
						name='pulseVersion'
						label='Latest recommended version'
						rules={[{ required: true, message: 'Enter version (e.g. 1.0.0)' }]}
					>
						<Input placeholder='e.g. 1.0.0' />
					</Form.Item>
					<Form.Item
						name='apkUrl'
						label='APK URL'
						rules={[{ required: true, message: 'Enter APK URL' }]}
					>
						<Input placeholder='https://...' />
					</Form.Item>
					<Form.Item name='description' label='Description'>
						<TextArea rows={4} placeholder='Release notes or description' />
					</Form.Item>
					<Form.Item>
						<Button type='primary' htmlType='submit' loading={loading}>
							Save
						</Button>
					</Form.Item>
				</Form>
			</Card>
		</>
	)
}

export default PulseRelease
